import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Box, Button, LottiePlayer, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import BigConfirmationCheckmarkIcon from '~/pages/VendorDashboard/BusinessSetupWidget/BigConfirmationCheckmarkIcon.json';
import styles from './InvoiceStatusScreen.module.scss';
export const GetInvoiceStatusScreenTID = (parentTestId)=>getTestIds(parentTestId);
export const InvoiceStatusScreen = (param)=>{
    let { title, subtitle, description, primaryAction, secondaryAction, hideLottie, footer, animate, testId } = param;
    const { InvoiceStatusScreenTestIds } = useMemo(()=>GetInvoiceStatusScreenTID(testId), [
        testId
    ]);
    const showButtons = primaryAction != null || secondaryAction != null;
    return /*#__PURE__*/ _jsxs(Box, {
        testId: InvoiceStatusScreenTestIds.Root(),
        className: cn(styles.screen, animate && styles.gradualReveal),
        children: [
            !hideLottie && /*#__PURE__*/ _jsx(Box, {
                testId: InvoiceStatusScreenTestIds.LottieIcon(),
                className: styles.lottieIcon,
                children: /*#__PURE__*/ _jsx(LottiePlayer, {
                    animationData: BigConfirmationCheckmarkIcon,
                    loop: false,
                    autoplay: true
                })
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h3",
                weight: "normal",
                testId: InvoiceStatusScreenTestIds.Title(),
                children: title
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h6",
                weight: "light",
                testId: InvoiceStatusScreenTestIds.Subtitle(),
                className: styles.subtitle,
                children: subtitle
            }),
            description != null && /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                weight: "light",
                testId: InvoiceStatusScreenTestIds.Description(),
                className: styles.description,
                children: description
            }),
            showButtons && /*#__PURE__*/ _jsxs(Row, {
                className: styles.buttons,
                gap: 12,
                children: [
                    secondaryAction != null && /*#__PURE__*/ _jsx(Button, {
                        bi: {
                            name: secondaryAction.biName
                        },
                        skin: "primaryOutline",
                        testId: InvoiceStatusScreenTestIds.SecondaryActionButton(),
                        loading: secondaryAction.loading,
                        disabled: secondaryAction.disabled,
                        tooltip: secondaryAction.tooltipTitle ? {
                            title: secondaryAction.tooltipTitle
                        } : undefined,
                        onClick: secondaryAction.onClick,
                        children: secondaryAction.label
                    }),
                    primaryAction != null && /*#__PURE__*/ _jsx(Button, {
                        bi: {
                            name: primaryAction.biName
                        },
                        skin: "primary",
                        testId: InvoiceStatusScreenTestIds.PrimaryActionButton(),
                        loading: primaryAction.loading,
                        disabled: primaryAction.disabled,
                        tooltip: primaryAction.tooltipTitle ? {
                            title: primaryAction.tooltipTitle
                        } : undefined,
                        onClick: primaryAction.onClick,
                        children: primaryAction.label
                    })
                ]
            }),
            footer != null && /*#__PURE__*/ _jsx(Box, {
                testId: InvoiceStatusScreenTestIds.Footer(),
                children: footer
            })
        ]
    });
};
